import * as React from "react";
import { styled } from "@mui/material";
import HeaderTitle from "./UI/HeaderTitle";
import { ReactComponent as Send } from "../assets/sendIcon.svg";
import { Colors } from "../styles/Theme";
import useSessionStore from "../context/useSessionStore";
import { useEventReportedContext } from "../analytics/EventReporterContext";
import { MIX_PANEL_EVENTS } from "../analytics/eventReporter";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";

//region [[ Styles ]]

const SuggestedQuestionView = styled("div")(({ theme }) => ({
  margin: "20px 0",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    marginLeft: -44,
    width: "calc(100% + 44px)",
  },
}));
const QuestionsList = styled("div")(({ theme }) => ({
  display: "grid",
  width: "100%",
  gap: 14,
  gridTemplateColumns: "repeat(auto-fill, minmax(240px, max-content))",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    flexDirection: "column",
  },
}));
const QuestionButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 10,
  padding: 20,
  background: "#FFFFFF",
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
  height: "100%",
  textAlign: "left",
  textTransform: "none",
  borderRadius: 8,
  fontSize: 14,
  lineHeight: 1.3,
  cursor: "pointer",
  "& .buttonTxt": { opacity: 0.6 },
  "& .buttonIcon": {
    transition: "opacity 0.2s",
    opacity: 0,
    color: theme.palette.primary.main,
  },
  "&:hover": {
    background: Colors.lightBackground,
    "& .buttonTxt": { opacity: 1 },
    "& .buttonIcon": { opacity: 1 },
  },
  "&:dir(rtl)": {
    textAlign: "right",
  },
  "&:dir(rtl) .buttonIcon": {
    transform: "rotate(180deg)",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SuggestedQuestionProps {
  questions: string[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SuggestedQuestion = ({ ...props }: SuggestedQuestionProps) => {
  const { addQuestion, ragSettings } = useSessionStore();
  const reporter = useEventReportedContext();
  const { translate } = useTranslateByGender();
  const rtlDisplay = ragSettings?.rtlDisplay;
  return (
    <SuggestedQuestionView dir={rtlDisplay ? "rtl" : ""}>
      <HeaderTitle>{translate("DIALOGUE_SUGGESTED_QUESTIONS")}</HeaderTitle>
      <QuestionsList>
        {props.questions.map((question, i) => (
          <QuestionButton
            onClick={() => {
              reporter.reportEvent(MIX_PANEL_EVENTS.SUGGESTED_SELECTED, {
                question,
                withSuggestions: true,
              });
              addQuestion(question, (answer) => reporter.reportAnswer(answer));
            }}
            key={"suggestion" + i}
          >
            <span className={"buttonTxt"}>{question}</span>
            <span className={"buttonIcon"}>
              <Send />
            </span>
          </QuestionButton>
        ))}
      </QuestionsList>
    </SuggestedQuestionView>
  );
};
